"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeBulkUpload = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/components/form-parts/file-upload/component");
const form_parts_1 = require("@front/components/form-parts");
const axios_1 = __importDefault(require("axios"));
const component_3 = require("@front/components/google-drive-directory-picker/component");
const AccountLimitService_1 = __importStar(require("@front/services/AccountLimitService"));
const component_4 = require("@front/layouts/default-layout/component");
// Import components to ensure they are available
component_2.FileUploadPart;
component_3.GoogleDriveDirectoryPicker;
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="knowledge-bulk-upload-page">
    
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h2>${'knowledge.bulk_upload.title'.t()}</h2>
        <p class="text-muted">${'knowledge.bulk_upload.description'.t()}</p>
      </div>
      <button type="button" class="btn btn-outline-secondary" @click="${x => x.goBack()}">
        <i class="simple-icon-arrow-left"></i> ${'common.back'.t()}
      </button>
    </div>

    
    <div class="card">
      <div class="card-body">
        <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
          
          
          <div class="mb-4">
            <label class="form-label">${'knowledge.bulk_upload.upload_mode'.t()}</label>
            <div class="form-check-group">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="uploadMode" id="files-mode" 
                       :checked="${x => x.uploadMode === 'files'}" 
                       @change="${x => x.switchUploadMode('files')}">
                <label class="form-check-label" for="files-mode">
                  <i class="simple-icon-cloud-upload me-2"></i>
                  ${'knowledge.bulk_upload.mode.files'.t()}
                </label>
              </div>
              
              <div class="form-check">
                <input class="form-check-input" type="radio" name="uploadMode" id="google-drive-mode" 
                       :checked="${x => x.uploadMode === 'google-drive-directory'}"
                       @change="${x => x.switchUploadMode('google-drive-directory')}"
                       :disabled="${x => !x.googleDriveAuthenticated}">
                <label class="form-check-label" for="google-drive-mode" 
                       :class="${x => x.googleDriveAuthenticated ? '' : 'text-muted'}"
                       title="${x => x.googleDriveAuthenticated ? '' : 'knowledge.bulk_upload.google_drive_not_connected'.t()}">
                  <i class="simple-icon-folder me-2"></i>
                  ${'knowledge.bulk_upload.mode.google_drive_directory'.t()}
                </label>
              </div>
            </div>
            <small class="form-text text-muted" ?hidden="${x => x.googleDriveAuthenticated}">
              <i class="simple-icon-exclamation me-1"></i>
              ${'knowledge.bulk_upload.google_drive_setup_required'.t()}
            </small>
          </div>
          
          
          <div class="mb-4">
            <part-select 
              class="form-part" 
              label="${'project'.t()} ${'common.required'.t()}" 
              required="true"
              :value="${x => x.form.projectId}" 
              name="projectId"
              :options="${x => [{ label: 'project.none'.t(), value: '' }, ...x.projects.map(project => ({ label: project.name, value: project.id }))]}">
            </part-select>
            <small class="form-text text-muted">${'knowledge.bulk_upload.project_help'.t()}</small>
          </div>

          
          <div class="mb-4" ?hidden="${x => x.uploadMode !== 'files'}">
            <part-file-upload 
              class="form-part"
              label="${'knowledge.bulk_upload.files'.t()}"
              name="files"
              required="true"
              multiple="true"              
              mode="file"              
              accept=".pdf,.doc,.docx,.txt,.md,.html,.htm,.rtf,.css,.scss,.js,.jsx,.ts,.tsx,.zip,.tar,.tar.gz,.tgz,.tar.bz2,.bz2"
              placeholder="${'knowledge.bulk_upload.files_placeholder'.t()}"
              :value="${x => x.form.files}">
            </part-file-upload>
            <small class="form-text text-muted">${'knowledge.bulk_upload.files_help'.t()}</small>
            <small class="form-text text-info">
              <i class="simple-icon-folder"></i> ${'knowledge.bulk_upload.archive_support'.t()}
            </small>
            
            
            <div class="mt-2" ?hidden="${x => !x.knowledgeLimitInfo.message}">
              <small class="form-text ${x => x.knowledgeLimitInfo.canUpload ? 'text-info' : 'text-danger'}">
                <i class="${x => x.knowledgeLimitInfo.canUpload ? 'simple-icon-info' : 'simple-icon-exclamation'} me-1"></i>
                ${x => x.knowledgeLimitInfo.message || ''}
              </small>
            </div>
          </div>

          
          <div class="mb-4" ?hidden="${x => x.uploadMode !== 'google-drive-directory'}">            
                         
            <div class="alert alert-info d-flex align-items-center" style="display: ${x => x.selectedDirectory !== null ? 'inherit' : 'none !important;'}">
              ${x => console.log(typeof x.selectedDirectory, String(x.selectedDirectory))}
              <i class="simple-icon-folder text-warning me-3"></i>
              <div class="flex-grow-1">
                <strong>${x => { var _a; return ((_a = x.selectedDirectory) === null || _a === void 0 ? void 0 : _a.name) || ''; }}</strong>
                <br>
                <small class="text-muted">${'knowledge.bulk_upload.selected_directory'.t()}</small>
              </div>
              <button type="button" class="btn btn-sm btn-outline-danger" @click="${x => x.clearSelectedDirectory()}">
                <i class="simple-icon-close"></i> ${'common.clear'.t()}
              </button>
            </div>

            
            <div class="d-grid mb-3">
              <google-drive-directory-picker 
                buttonClass="btn btn-success btn-lg"
                @directory-selected="${(x, c) => x.onGoogleDriveDirectorySelected(c.event)}"
                @picker-cancelled="${(x, c) => x.onGoogleDrivePickerCancelled()}">
                <i class="simple-icon-folder-alt me-2"></i>
                ${'knowledge.bulk_upload.google_drive_select_directory'.t()}
              </google-drive-directory-picker>
            </div>
            
            <small class="form-text text-muted">${'knowledge.bulk_upload.google_drive_directory_help'.t()}</small>
          </div>

          
          <div class="mb-4">
            <part-tags 
              class="form-part" 
              label="${'knowledge.tags'.t()}" 
              :value="${x => x.form.tags}" 
              name="tags"
              >
            </part-tags>
            <small class="form-text text-muted">${'knowledge.tags.help'.t()}</small>
          </div>

          
          <div class="alert alert-info">
            <h6><i class="simple-icon-exclamation"></i> ${'knowledge.bulk_upload.info.title'.t()}</h6>
            <ul class="mb-0" ?hidden="${x => x.uploadMode !== 'files'}">
              <li>${'knowledge.bulk_upload.info.title_from_filename'.t()}</li>
              <li>${'knowledge.bulk_upload.info.description_auto'.t()}</li>
              <li>${'knowledge.bulk_upload.info.group_optional'.t()}</li>
              <li>${'knowledge.bulk_upload.info.tags_shared'.t()}</li>
              <li>${'knowledge.bulk_upload.info.rag_auto_index'.t()}</li>
              <li><strong>${'knowledge.bulk_upload.info.archive_extraction'.t()}</strong></li>
            </ul>
            <ul class="mb-0" ?hidden="${x => x.uploadMode !== 'google-drive-directory'}">
              <li>${'knowledge.bulk_upload.info.google_drive.all_files'.t()}</li>
              <li>${'knowledge.bulk_upload.info.title_from_filename'.t()}</li>
              <li>${'knowledge.bulk_upload.info.google_drive.content_fetch'.t()}</li>
              <li>${'knowledge.bulk_upload.info.google_drive.project_required'.t()}</li>
              <li>${'knowledge.bulk_upload.info.tags_shared'.t()}</li>
              <li>${'knowledge.bulk_upload.info.rag_auto_index'.t()}</li>
              <li><strong>${'knowledge.bulk_upload.info.google_drive.file_support'.t()}</strong></li>
            </ul>
          </div>

          
          <div class="text-right">
            <button type="button" class="btn btn-secondary mr-2" @click="${(x, c) => x.cancel(c.event)}" :disabled="${x => x.isLoading}">
              ${'common.cancel'.t()}
            </button>
            <button type="button" 
                    @click="${(x, c) => x.sendForm(c.event)}" 
                    class="btn ${x => x.uploadMode === 'google-drive-directory' ? 'btn-success' : 'btn-primary'}" 
                    :disabled="${x => x.isLoading || !x.canSubmit}">
              <span ?hidden="${x => !x.isLoading}" class="spinner-border spinner-border-sm me-2"></span>
              <i class="${x => x.uploadMode === 'google-drive-directory' ? 'simple-icon-folder' : 'simple-icon-cloud-upload'} me-2" ?hidden="${x => x.isLoading}"></i>
              ${x => {
    if (x.isLoading) {
        return x.uploadMode === 'google-drive-directory'
            ? 'knowledge.bulk_upload.google_drive_processing'.t()
            : 'knowledge.bulk_upload.uploading'.t();
    }
    return x.uploadMode === 'google-drive-directory'
        ? 'knowledge.bulk_upload.google_drive_process'.t()
        : 'knowledge.bulk_upload.upload'.t();
}}
            </button>
          </div>

        </the-form>
      </div>
    </div>

    
    ${x => x.isLoading ? `
      <div class="mt-3">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%">
            <i class="simple-icon-clock me-2"></i>
            ${'knowledge.bulk_upload.processing'.t()}
          </div>
        </div>
      </div>
    ` : ''}

  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.form-check-group .form-check {
  display: inline-block;
  margin-right: 2rem;
  margin-bottom: 0.5rem;
}
.form-check-group .form-check .form-check-input {
  margin-top: 0.25rem;
}
.form-check-group .form-check .form-check-label {
  margin-left: 0.5rem;
  cursor: pointer;
}
.form-check-group .form-check .form-check-label i {
  color: var(--theme-color-1);
}
.form-check-group .form-check .form-check-label.text-muted {
  cursor: not-allowed;
  opacity: 0.6;
}
.form-check-group .form-check .form-check-label.text-muted i {
  color: var(--theme-text-muted);
}`;
const shadowOptions = { "mode": "open" };
let KnowledgeBulkUpload = class KnowledgeBulkUpload extends client_1.RWSViewComponent {
    constructor(accountLimitService) {
        super();
        this.accountLimitService = accountLimitService;
        this.form = {
            files: [],
            projectId: '',
            tags: []
        };
        this.projects = [];
        this.isLoading = false;
        this.googleDriveAuthenticated = false;
        this.selectedDirectory = null;
        this.uploadMode = 'files';
        this.knowledgeLimitInfo = {
            currentCount: 0,
            maxEntries: null,
            canUpload: true
        };
        this.sendSubmit = form_parts_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadProjects();
        await this.checkGoogleDriveStatus();
        await this.updateKnowledgeLimitInfo();
        form_parts_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    async loadProjects() {
        var _a;
        try {
            const response = await this.apiService.back.get('project.list', { queryParams: { all: '1' } });
            if (response.success) {
                this.projects = response.data || [];
            }
        }
        catch (error) {
            console.error('Error loading projects:', error);
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('Failed to load projects', 'error');
        }
    }
    async sendForm(event) {
        var _a, _b;
        event.preventDefault();
        if (this.uploadMode === 'files') {
            if (!this.form.files || this.form.files.length === 0) {
                (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('Please select at least one file', 'error');
                return;
            }
            await this.uploadFiles();
        }
        else if (this.uploadMode === 'google-drive-directory') {
            if (!this.selectedDirectory) {
                (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify('Please select a Google Drive directory', 'error');
                return;
            }
            await this.uploadGoogleDriveDirectory();
        }
    }
    async uploadFiles() {
        var _a, _b, _c, _d, _e, _f, _g;
        // Prevent multiple simultaneous submissions
        if (this.isLoading) {
            console.warn('Upload already in progress, ignoring duplicate submission');
            return;
        }
        // Project is required for file uploads
        if (!this.form.projectId || this.form.projectId.trim() === '') {
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('Please select a project before uploading', 'error');
            return;
        }
        // Check knowledge limit for bulk upload
        const limitCheck = await this.accountLimitService.checkBulkResourceLimit('knowledge', this.form.files.length);
        if (!limitCheck.canCreate) {
            (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify(limitCheck.message, 'error');
            return;
        }
        this.isLoading = true;
        try {
            // Build FormData with all files under single 'files' field
            const formData = new FormData();
            for (const fileItem of this.form.files) {
                const file = fileItem.path;
                formData.append('files', file);
            }
            if (this.form.projectId) {
                formData.append('projectId', this.form.projectId);
            }
            if (this.form.tags && this.form.tags.length > 0) {
                formData.append('tags', JSON.stringify(this.form.tags));
            }
            const url = this.apiService.getBackendUrl('knowledge.bulk-upload');
            const headers = {
                'Content-Type': 'multipart/form-data',
            };
            if (this.apiService.token) {
                headers['Authorization'] = `Bearer ${this.apiService.token}`;
            }
            const { data: response } = await axios_1.default.post(url, formData, { headers });
            if (response.success) {
                if (response.successCount > 0 && response.errorCount === 0) {
                    (_c = this.notifyService) === null || _c === void 0 ? void 0 : _c.notify('knowledge.bulkUpload.files.successProcessing'.t().replace('{count}', response.successCount.toString()), 'info');
                    this.goBack();
                }
                else if (response.successCount > 0 && response.errorCount > 0) {
                    (_d = this.notifyService) === null || _d === void 0 ? void 0 : _d.notify('knowledge.bulkUpload.files.partialSuccess'.t().replace('{successCount}', response.successCount.toString()).replace('{errorCount}', response.errorCount.toString()), 'error');
                }
                else {
                    (_e = this.notifyService) === null || _e === void 0 ? void 0 : _e.notify('knowledge.bulkUpload.files.allFailed'.t().replace('{count}', response.errorCount.toString()), 'error');
                }
            }
            else {
                (_f = this.notifyService) === null || _f === void 0 ? void 0 : _f.notify('Failed to upload files', 'error');
            }
        }
        catch (error) {
            console.error('Bulk upload error:', error);
            (_g = this.notifyService) === null || _g === void 0 ? void 0 : _g.notify('An unexpected error occurred during upload', 'error');
        }
        finally {
            this.isLoading = false;
        }
    }
    async uploadGoogleDriveDirectory() {
        var _a, _b, _c, _d;
        console.log('[BulkUpload] Starting Google Drive directory upload...');
        // Prevent multiple simultaneous submissions
        if (this.isLoading) {
            console.warn('[BulkUpload] Upload already in progress, ignoring duplicate submission');
            return;
        }
        console.log('[BulkUpload] 🚀 UPLOAD START - Current selectedDirectory:', JSON.stringify(this.selectedDirectory, null, 2));
        console.log('[BulkUpload] 📋 UPLOAD START - Current form data:', JSON.stringify(this.form, null, 2));
        console.log('[BulkUpload] Google Drive authenticated:', this.googleDriveAuthenticated);
        if (!this.selectedDirectory) {
            console.error('[BulkUpload] ❌ No selectedDirectory found!');
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('No Google Drive directory selected', 'error');
            return;
        }
        // Project is optional for Google Drive uploads
        if (!this.form.projectId || this.form.projectId.trim() === '') {
            console.log('[BulkUpload] ℹ️ No project selected - proceeding without project assignment');
        }
        this.isLoading = true;
        try {
            // Create JSON payload (backend expects JSON, not FormData)
            const payload = {
                directoryId: this.selectedDirectory.id,
                projectId: this.form.projectId || undefined,
                tags: this.form.tags && this.form.tags.length > 0 ? Array.from(this.form.tags) : undefined
            };
            console.log('📝 PAYLOAD CREATION (NEW JSON VERSION):');
            console.log('  - projectId:', this.form.projectId || '(empty)');
            console.log('  - directoryId:', this.selectedDirectory.id);
            console.log('  - directoryName:', this.selectedDirectory.name);
            console.log('  - tags array:', this.form.tags);
            console.log('  - tags converted:', payload.tags);
            console.log('[BulkUpload] 📦 FINAL JSON PAYLOAD (NOT FORMDATA):');
            console.log(JSON.stringify(payload, null, 2));
            console.log('[BulkUpload] Making API call to knowledge.google-drive-directory-upload...');
            const response = await this.apiService.back.post('knowledge.google-drive-directory-upload', payload);
            console.log('[BulkUpload] API response received:', response);
            if (response === null || response === void 0 ? void 0 : response.success) {
                console.log('[BulkUpload] ✅ Google Drive directory upload successful');
                (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify('knowledge.bulkUpload.googleDrive.successProcessing'.t().replace('{directoryName}', this.selectedDirectory.name), 'info');
                // Reset form
                this.form.projectId = '';
                this.form.tags = [];
                this.selectedDirectory = null;
                // Navigate back to knowledge list
                this.goBack();
            }
            else {
                console.error('[BulkUpload] ❌ Google Drive directory upload failed:', response);
                (_c = this.notifyService) === null || _c === void 0 ? void 0 : _c.notify((response === null || response === void 0 ? void 0 : response.error) || 'Failed to process Google Drive directory', 'error');
            }
        }
        catch (error) {
            console.error('Google Drive directory upload error:', error);
            (_d = this.notifyService) === null || _d === void 0 ? void 0 : _d.notify('Failed to process Google Drive directory', 'error');
        }
        finally {
            this.isLoading = false;
        }
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/ai/knowledge/list');
    }
    cancel(event) {
        event.preventDefault();
        this.goBack();
    }
    async checkGoogleDriveStatus() {
        try {
            const response = await this.apiService.back.get('settings.google-drive.status');
            if (response && response.success && response.data) {
                this.googleDriveAuthenticated = response.data.authenticated;
            }
        }
        catch (error) {
            console.error('Failed to check Google Drive status:', error);
            this.googleDriveAuthenticated = false;
        }
    }
    switchUploadMode(mode) {
        this.uploadMode = mode;
        // Reset form data when switching modes
        if (mode === 'files') {
            this.selectedDirectory = null;
        }
        else {
            this.form.files = [];
        }
    }
    onGoogleDriveDirectorySelected(event) {
        var _a;
        console.log('📥 BULK UPLOAD - Directory selected event received:', event);
        console.log('📋 Event detail:', JSON.stringify(event.detail, null, 2));
        const directory = event.detail.directory;
        console.log('📁 Extracted directory object:', JSON.stringify(directory, null, 2));
        this.selectedDirectory = directory;
        console.log('✅ BULK UPLOAD - this.selectedDirectory set to:', JSON.stringify(this.selectedDirectory, null, 2));
        (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify(`Selected Google Drive directory: ${directory.name}`, 'info');
    }
    onGoogleDrivePickerCancelled() {
        console.log('Google Drive directory picker was cancelled');
    }
    clearSelectedDirectory() {
        var _a;
        this.selectedDirectory = null;
        (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('Google Drive directory selection cleared', 'info');
    }
    async updateKnowledgeLimitInfo() {
        var _a, _b;
        try {
            const user = component_4.DefaultLayout.USER;
            const maxEntries = ((_a = user === null || user === void 0 ? void 0 : user.accountGrade) === null || _a === void 0 ? void 0 : _a.maxKnowledgeEntries) || null;
            // Get current count using the API call directly 
            let currentCount = 0;
            try {
                const response = await this.apiService.back.get('knowledge.list', {
                    queryParams: { per_page: '1' }
                });
                currentCount = (response === null || response === void 0 ? void 0 : response.count) || 0;
            }
            catch (error) {
                console.error('Error fetching knowledge count:', error);
                currentCount = 0;
            }
            const filesToUpload = ((_b = this.form.files) === null || _b === void 0 ? void 0 : _b.length) || 0;
            const canUpload = filesToUpload === 0 ? true : (await this.accountLimitService.checkBulkResourceLimit('knowledge', filesToUpload)).canCreate;
            let message;
            if (!canUpload && filesToUpload > 0) {
                const limitCheck = await this.accountLimitService.checkBulkResourceLimit('knowledge', filesToUpload);
                message = limitCheck.message;
            }
            else if (maxEntries !== null) {
                const remaining = maxEntries - currentCount;
                message = 'knowledge.bulk_upload.limit_info'.t()
                    .replace('{current}', currentCount.toString())
                    .replace('{max}', maxEntries.toString())
                    .replace('{remaining}', remaining.toString());
            }
            this.knowledgeLimitInfo = {
                currentCount,
                maxEntries,
                canUpload,
                message
            };
        }
        catch (error) {
            console.error('Error checking knowledge limits:', error);
        }
    }
    formChanged() {
        // Update limit info when files change
        this.updateKnowledgeLimitInfo();
    }
    get canSubmit() {
        if (this.uploadMode === 'files') {
            return !!(this.form.files && this.form.files.length > 0 && this.knowledgeLimitInfo.canUpload);
        }
        else if (this.uploadMode === 'google-drive-directory') {
            return !!this.selectedDirectory;
        }
        return false;
    }
};
exports.KnowledgeBulkUpload = KnowledgeBulkUpload;
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], KnowledgeBulkUpload.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgeBulkUpload.prototype, "projects", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgeBulkUpload.prototype, "isLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgeBulkUpload.prototype, "googleDriveAuthenticated", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof component_3.GoogleDriveFolder !== "undefined" && component_3.GoogleDriveFolder) === "function" ? _b : Object)
], KnowledgeBulkUpload.prototype, "selectedDirectory", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], KnowledgeBulkUpload.prototype, "uploadMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], KnowledgeBulkUpload.prototype, "knowledgeLimitInfo", void 0);
exports.KnowledgeBulkUpload = KnowledgeBulkUpload = __decorate([
    (0, client_1.RWSView)('knowledge-bulk-upload', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(AccountLimitService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof AccountLimitService_1.AccountLimitServiceInstance !== "undefined" && AccountLimitService_1.AccountLimitServiceInstance) === "function" ? _a : Object])
], KnowledgeBulkUpload);
KnowledgeBulkUpload.defineComponent();
